import React, { useState } from 'react';

import Loading from "../../../component/loading/Loading";
import Modal from "../../../component/modal/ModalTemplate";
import TextInput from "../../../component/input/TextInput";

import * as apiUtil from "../../../util/apiUtil";
import { aesEncrypt } from "../../../util/aes256";
import { PRIMARY_BTN, SECONDARY_BTN, INPUT, LABEL, LIST, FOOTER_END } from "./modalStyle";

interface AuthToChangeInfoModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    openChangeCate: () => void;
}

const AuthToChangeInfoModal: React.FC<AuthToChangeInfoModalProps> = ({ isOpen, onRequestClose, openChangeCate }) => {
    const [loading, setLoading] = useState(false);
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');

    const setValue = (id: string, value: string) => {
        switch (id) {
            case "password1":
                setPassword1(value);
                break;
            case "password2":
                setPassword2(value);
                break;
        }
    };

    const ajaxVerifyPassword = () => {
        apiUtil.asyncRequest({
            setLoading,
            url: "/api/bizchat/user/verify/password",
            method: apiUtil.requestMethod.POST,
            data: {
                password1: aesEncrypt(password1),
                password2: aesEncrypt(password2),
            },
            success: (result: boolean) => {
                if (result) {
                    alert('비밀번호가 일치합니다!');
                    openChangeCate();
                    onRequestClose();
                } else {
                    alert('비밀번호가 일치 하지 않습니다!');
                }
            },
        });
    };

    return (
        <Modal
            open={isOpen}
            handleClose={onRequestClose}
            modalTitle="내 정보 수정하기"
            className="react-modal"
        >
            <Loading loading={loading} />
            <div className="modal-body">
                <ul className={LIST}>
                    <li>
                        <label className={LABEL}>비밀번호</label>
                        <TextInput
                            className={INPUT}
                            type="password"
                            id="password1"
                            value={password1}
                            onChange={setValue}
                            placeholder="비밀번호를 입력해주세요"
                        />
                    </li>
                    <li>
                        <label className={LABEL}>비밀번호 확인</label>
                        <TextInput
                            className={INPUT}
                            type="password"
                            id="password2"
                            value={password2}
                            onChange={setValue}
                            placeholder="비밀번호를 재확인해주세요"
                            onKeyDown={ajaxVerifyPassword}
                        />
                    </li>
                </ul>
            </div>
            <div className={FOOTER_END}>
                <button type="button" className={PRIMARY_BTN} onClick={() => ajaxVerifyPassword()}>확인</button>
                <button type="button" className={SECONDARY_BTN} onClick={onRequestClose}>취소</button>
            </div>
        </Modal>
    );
};

export default AuthToChangeInfoModal;
